import React, { useRef } from 'react';
import Modal from '../shared/Modal';

const RemoveMemberModal = ({ open, onClose, member, onConfirm, currentUserRole }) => {
    const cancelRef = useRef(null);
    const confirmRef = useRef(null);

    if (!open || !member) return null;

    const getRoleLabel = (role) => {
        const labels = {
            owner: 'Propriétaire',
            admin: 'Administrateur',
            member: 'Membre'
        };
        return labels[role] || role;
    };

    const getRoleBadgeColor = (role) => {
        const colors = {
            owner: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
            admin: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300',
            member: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'
        };
        return colors[role] || colors.member;
    };

    const getWarningMessage = () => {
        if (member.role === 'owner') {
            return (
                <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded p-3 mb-4">
                    <p className="text-sm text-red-800 dark:text-red-300 font-medium">
                        ⚠️ Attention : Vous êtes sur le point de retirer un propriétaire !
                    </p>
                    <p className="text-xs text-red-600 dark:text-red-400 mt-1">
                        Assurez-vous qu'il reste au moins un autre propriétaire dans l'organisation.
                    </p>
                </div>
            );
        }
        return null;
    };

    // Modal actions
    const modalActions = (
        <>
            <button
                ref={cancelRef}
                onClick={onClose}
                className="flex-1 bg-gray-300 dark:bg-gray-700 text-gray-800 dark:text-gray-200 font-bold py-2 px-4 rounded-lg hover:bg-gray-400 dark:hover:bg-gray-600 transition"
            >
                Annuler
            </button>
            <button
                ref={confirmRef}
                onClick={onConfirm}
                className="flex-1 bg-red-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-red-700 transition"
            >
                Retirer le membre
            </button>
        </>
    );

    return (
        <Modal
            open={open}
            onClose={onClose}
            title="Retirer un membre"
            actions={modalActions}
            initialFocusRef={confirmRef}
        >
            {/* Body */}
            <div>
                {getWarningMessage()}

                <div className="mb-4">
                    <p className="text-gray-700 dark:text-gray-300 mb-4">
                        Êtes-vous sûr de vouloir retirer <strong>{member.name}</strong> de l'organisation ?
                    </p>

                    <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-4 space-y-2">
                        <div className="flex items-center justify-between">
                            <span className="text-sm text-gray-600 dark:text-gray-400">Email :</span>
                            <span className="text-sm font-medium text-black dark:text-white">
                                {member.email}
                            </span>
                        </div>
                        <div className="flex items-center justify-between">
                            <span className="text-sm text-gray-600 dark:text-gray-400">Rôle :</span>
                            <span className={`text-xs px-2 py-1 rounded ${getRoleBadgeColor(member.role)}`}>
                                {getRoleLabel(member.role)}
                            </span>
                        </div>
                        {member.joinedAt && (
                            <div className="flex items-center justify-between">
                                <span className="text-sm text-gray-600 dark:text-gray-400">Membre depuis :</span>
                                <span className="text-sm font-medium text-black dark:text-white">
                                    {new Date(member.joinedAt).toLocaleDateString('fr-FR')}
                                </span>
                            </div>
                        )}
                    </div>
                </div>

                <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded p-3">
                    <p className="text-sm text-yellow-800 dark:text-yellow-300">
                        💡 Cette action est irréversible. L'utilisateur devra utiliser un code d'invitation pour rejoindre à nouveau l'organisation.
                    </p>
                </div>
            </div>
        </Modal>
    );
};

export default RemoveMemberModal;